<script lang="ts">
	import { onMount } from "svelte";
	import { makeComponentClassList } from "../utils";

	export let value = "";
	export let placeholder = "";
	export let defaultClassName = "";
	export let disabled = false;
	export let error = false;
	export let length: number = Infinity;
	export let id = "";
	export let clearCallback: () => void = () => {};
	export let clearButtonDisplay = false;
	export let password = false;

	$: classVariables = makeComponentClassList($$props);

	let input: HTMLInputElement;
	let focus = false;

	onMount(() => {
		const outerFocus = () => {
			focus = true;
		};
		const outerBLUR = () => {
			focus = false;
		};

		input.addEventListener("focus", outerFocus);
		input.addEventListener("blur", outerBLUR);
	});

</script>

<div
	class:focus
	class:disabled
	class:hasSlot={clearButtonDisplay}
	class={defaultClassName + classVariables}
	on:click={() => input.focus()}>
	{#if password}
		<input
			id={id}
			name={id}
			type="password"
			disabled={disabled}
			placeholder={placeholder}
			maxlength={length}
			class:error
			bind:value
			bind:this={input}
			on:input
			on:focus
			on:blur
			on:keydown />
	{:else}
		<input
			id={id}
			name={id}
			type="text"
			disabled={disabled}
			placeholder={placeholder}
			maxlength={length}
			class:error
			bind:value
			bind:this={input}
			on:input
			on:focus
			on:blur
			on:keydown />
	{/if}

	{#if clearButtonDisplay}
		<i on:click={() => clearCallback()}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="15"
				height="15"
				viewBox="0 0 15 15">
				<line x1="0" y1="0" x2="15" y2="15" stroke-width="1" />
				<line x1="0" y1="15" x2="15" y2="0" stroke-width="1" />
			</svg>
		</i>
	{/if}
</div>

<style lang="scss">
	i {
		display: flex;
		align-items: center;
	}

	div {
		display: flex;
		width: 100%;
		height: 40px;
		border-radius: 5px;
		border: none;
		padding: 10px;
		box-sizing: border-box;
		transition: box-shadow 0.1s;
		background-color: white;
		cursor: text;

		&.focus {
			outline: none;
			box-shadow: 0 0 0 2pt var(--signature-blue);
		}

		&.disabled {
			background-color: var(--default-disabled-btn-1);
		}

		&.hasSlot {
			display: flex;
			align-items: center;
			svg {
				line {
					stroke: #bcbfc3;
					transition: stroke 0.15s;
				}
			}

			i:hover {
				cursor: pointer;

				line {
					stroke: #686a6d;
				}
			}

			input {
				flex-grow: 1;
			}
		}
	}

	input {
		width: 100%;
		font-size: 1.125rem;
		font-weight: 200;
		background: none;
		border: none;
		outline: none;
		color: var(--default-disabled-btn-2);
		padding: 0;
		&::placeholder {
			color: var(--default-disabled-btn-1);
		}

		&:disabled {
			&::placeholder {
				color: white;
			}
		}

		&.error {
			color: var(--error-color-2);
		}
	}

</style>
